module.exports = __webpack_public_path__ + "img/yioks_keke2.bb6ce39a.png";